import { render } from "./ModalVotacionFestival.vue?vue&type=template&id=74c1afbc&scoped=true"
import script from "./ModalVotacionFestival.vue?vue&type=script&lang=js"
export * from "./ModalVotacionFestival.vue?vue&type=script&lang=js"

import "./ModalVotacionFestival.vue?vue&type=style&index=0&id=74c1afbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1afbc"]])

export default __exports__